import { cn } from "@gymflow/helpers";
import { ReactNode } from "react";

import Label from "./Label";
import { RadioButton } from "./RadioButton";

export type RadioButtonOption<T extends string | number> = {
  label: ReactNode;
  value: T;
};

export type RadioButtonGroupProps<T extends string | number> = {
  options: RadioButtonOption<T>[];
  value: T;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  name?: string;
  className?: string;
  label?: ReactNode;
  verticalLayout?: boolean;
  disabled?: boolean;
  isRequired?: boolean;
  labelClassName?: string;
  disabledTooltip?: string;
  isOptional?: boolean;
};

export const RadioButtonGroup = <T extends string | number>({
  options,
  value,
  onChange,
  name,
  className,
  label,
  verticalLayout,
  disabled,
  isRequired,
  disabledTooltip,
  isOptional,
}: RadioButtonGroupProps<T>) => (
  <div className="flex flex-col gap-2">
    <Label label={label} isRequired={isRequired} isOptional={isOptional} />
    <div
      className={cn(
        "flex gap-4",
        {
          "flex-row": !verticalLayout,
          "flex-col": verticalLayout,
          "opacity-30 cursor-not-allowed": disabled,
        },
        className,
      )}
    >
      {options.map((option, index) => (
        <RadioButton
          key={`${option.value}-${index}`}
          value={option.value}
          label={option.label}
          checked={value === option.value}
          onChange={onChange}
          name={name}
          disabledTooltip={disabledTooltip}
          disabled={disabled}
        />
      ))}
    </div>
  </div>
);
